export const stSuiFaqSection = [
    {
        question: 'What is stSUI?',
        answer: "stSUI (Staked SUI) is AlphaFi's instantly unstakable liquid staking token (LST) and the first implementation of the AlphaFi's stSUI LST Standard. It allows users to stake their SUI while maintaining liquidity, enabling them to freely transfer, trade, or use stSUI in DeFi protocols without losing access to staking rewards.",
    },
    {
        question: 'What is an LST?',
        answer: 'LST stands for Liquid Staking Token. It represents staked assets while providing liquidity to users. When you stake SUI to validate Sui network transactions, you receive an LST in return, such as stSUI.',
        introText: 'Unlike traditional staking, where your assets are locked and inaccessible, LSTs let you:\n',
        bullets: [
            'Earn Staking Rewards: Continue earning rewards from the underlying staked asset.',
            'Maintain Liquidity: Freely trade, transfer, or use the token in DeFi protocols (e.g., lending, borrowing, or yield farming).',
            'Unstake Instantly: Redeem LSTs for the original staked asset without waiting for lengthy unstaking periods.',
        ],
        listType: 'number',
        conclusionText: 'LSTs are revolutionizing staking by combining the benefits of staking with the flexibility of liquid assets.',
    },
    {
        question: "What is the AlphaFi's stSUI LST Standard?",
        answer: 'The stSUI Standard is an open-source liquid staking framework designed to provide enhanced liquidity and minimize depegging risks. By enabling instant unstaking and custom LST creation, it ensures secure and seamless staking experiences for users across the Sui ecosystem.',
    },
    {
        question: 'How does it work?',
        answer: 'When you stake SUI, you receive a liquid staking token, such as stSUI, representing your stake. Unlike traditional staking, stSUI enables instant redemption of tokens for SUI, eliminating risks of depegging during market volatility or liquidity shortages.',
        introText: 'Through the stSUI Standard, stSUI maintains strong liquidity reducing depegging risks, making it a safer option compared to other LSTs.',
    },
    {
        question: 'Why choose stSUI?',
        answer: 'stSUI, powered by the stSUI Standard, offers the following benefits:',
        bullets: [
            'Liquidity: stSUI tokens can be freely transferred, sold, or used in DeFi protocols while still earning staking rewards.',
            'Instant Unstaking: No waiting periods—unstake instantly for SUI.',
            'Yield Maximization: stSUI unlocks the full utility of your staked assets by integrating seamlessly with DeFi protocols.',
        ],
        listType: 'bullet',
    },
    {
        question: 'How is stSUI different from vSUI, haSUI, and afSUI?',
        answer: 'stSUI allows instant redemption of SUI by returning stSUI, unlike other LSTs. This feature minimizes depegging risks, providing a more secure and flexible staking experience.',
    },
    {
        question: 'How is stSUI different from SpringSUI and its Ecosystem LSTs?',
        answer: 'stSUI is forked from springSUI framework but has been further enhanced to optimize rewards when multiple validators are involved. It is designed to be more DeFi-friendly, supporting advanced features such as flash staking. Additionally, the redeem fee can be redistributed to users instead of being retained by the LST owner/operator, aligning incentives with the stakers.',
    },
    {
        question: 'How long does unstaking take?',
        answer: 'Unstaking stSUI is instant and requires just one transaction to convert back to SUI.',
    },
    {
        question: 'How do I collect my yield?',
        answer: "stSUI's yield is built into its price. At launch, 1 stSUI equals 1 SUI. As staking rewards accumulate, the value of stSUI increases (e.g., 1 stSUI = 1.05 SUI). This ensures holders benefit from staking rewards regardless of where their tokens are stored.",
    },
    {
        question: 'How are APRs determined?',
        answer: "stSUI's APR comes primarily from the Sui network staking rewards, influenced by factors such as:",
        bullets: [
            'Total staked SUI and network inflation.',
            'Validator performance (higher rewards for top-performing validators; penalties for poor ones).',
            'Commission fees charged by validators and protocol fees associated with stSUI.',
        ],
        boldText: false,
        listType: 'bullet',
        conclusionText: 'These factors collectively determine the final APR for stSUI holders.',
    },
    {
        question: 'What fees are associated with stSUI?',
        bullets: [
            'Performance Fee: A performance fee of 6% is applied to the yield generated and is deducted at each epoch (~1 day) directly from staking rewards.',
            'Redemption Fee: A minimal fee of 0.01% is charged when converting stSUI back to SUI to cover unstaking costs. Redeeming 1,000 stSUI incurs a fee of 0.1 SUI.',
        ],
        listType: 'number',
    },
    {
        question: 'What are the risks of using stSUI?',
        bullets: [
            'Smart Contract Risk: Like all liquid staking solutions, stSUI is vulnerable to smart contract exploits. A failure in the unstake mechanism could prevent token redemption, causing depegging or loss of value. The stSUI Standard mitigates these risks through rigorous audits and secure design.',
            'Validator Risk: Staking rewards depend on validator performance. Poor performance or slashing (penalties for validator misbehavior) can reduce rewards or result in loss of staked assets.',
        ],
        listType: 'number',
        conclusionText: 'By leveraging the stSUI Standard, stSUI minimizes these risks, offering users a reliable liquid staking solution.',
    },
];
